import { Modal, Result } from "antd";
import React from "react";

export const ModalError = ({ open, onCancel, message }) => (
  <Modal title="Erro!" visible={open} onCancel={onCancel} footer={null}>
    <Result status="warning" title={message} />
  </Modal>
);
